import React from "react";
// Components
import ModalOrBottomSheetWrapper from "@vahak/core-ui/dist/components/ModalOrBottomSheetWrapper";
import Button from "@vahak/core-ui/dist/components/Button";
import Typography from "@vahak/core-ui/dist/components/Typography";
import AppImg from "../../../utils/AppImg";
import AppLink from "../../../utils/app-link/AppLink";
import { ModalCrossIcon } from "@vahak/core-ui/dist/components/Modal/Modal";
import { VerticalFlex } from "@vahak/core-ui/dist/layout/Flex";
// Constants
import COLORS from "@vahak/core-ui/dist/constants/colors";
// Methods
// Hooks
import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";
// Assets
import Styles from "./Working.module.scss";
import ImgArrow from "@vahak/core/dist/icons/assured-step-arrow.svg";

interface WorkingProps {
    toggleModal?: () => void;
    type: "load-booking";
    isPaidBookingRequired?: boolean;
    isTapNgoLoad?: boolean;
    isSpotLoad?: boolean;
}

const Working = ({ toggleModal, type, isTapNgoLoad, isSpotLoad, isPaidBookingRequired }: WorkingProps) => {
    const isMobileScreen = useMediaQuery({ queryType: "mobile" });
    const list = {
        "load-booking": [
            {
                desc: "Post load and verify through OTP",
                imgName: "/assured-load-working-10.svg"
            },
            {
                desc: "Relax while we match your load with the perfect lorry",
                imgName: "/assured-load-working-12.svg"
            },
            {
                desc: isTapNgoLoad
                    ? "Get confirmation at your expected price or receive upto 3 counter offers from lorry owners to accept or reject"
                    : "Receive upto 3 offers from lorry owners. Accept or reject within 30 minutes, or your load will expire",
                imgName: "/assured-load-working-13.svg"
            }
        ]
    };
    return (
        <ModalOrBottomSheetWrapper
            isOpen
            showHeader={false}
            modalSize="fit"
            onToggle={toggleModal}
            fullScreenSheet
            renderFooter={
                <VerticalFlex gap={20} className={Styles.footer} padding={20}>
                    <Typography color={COLORS.BLUE} underline align="center">
                        <AppLink target="_blank" href={"/tapngo-terms-and-conditions"}>
                            *Terms & Conditions apply
                        </AppLink>
                    </Typography>
                    <Button blockBtn onClick={toggleModal}>
                        Got it
                    </Button>
                </VerticalFlex>
            }
        >
            <div className={Styles.main}>
                <div className={Styles.header}>
                    <Typography align="center" weight="medium" size="l" mSize="md">
                        How Vahak Assured Works?
                    </Typography>
                    <ModalCrossIcon onClick={toggleModal} />
                </div>

                <div className={Styles.body}>
                    <div className={Styles.list}>
                        {type &&
                            list[type].map((item, ix) => {
                                return (
                                    <div className={Styles.item} key={ix}>
                                        <div className={Styles.imgWrapper}>
                                            <div className={Styles.img}>
                                                <AppImg
                                                    src={item?.imgName}
                                                    unoptimized
                                                    {...(isMobileScreen
                                                        ? {
                                                              width: 200,
                                                              height: 145
                                                          }
                                                        : {
                                                              width: 150,
                                                              height: 110
                                                          })}
                                                />
                                            </div>
                                            <div className={Styles.arrow}>
                                                <ImgArrow />
                                            </div>
                                        </div>
                                        <div className={Styles.content}>
                                            <Typography size="md" weight="bold" color={COLORS.BLUE}>
                                                Step-{(ix + 1).toString().padStart(2, "0")}
                                            </Typography>
                                            <Typography size="m" mSize="s" weight="medium">
                                                {item?.desc}
                                            </Typography>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
        </ModalOrBottomSheetWrapper>
    );
};

export default Working;
